<template>
    <div class="column_container">
        <div class="column" v-for="(group, index) in columnList" :key="index">
			<div class="column__top">
				<div class="column__name">{{group.sort.sname}}</div>
				<a href="javascript:void(0);" @click="handleClick(group)" :class="group.display ? 'column__action show' : 'column__action hide'"></a>
			</div>
            <div class="column__list" v-show="!group.display">
                <ColumnCard v-for="(card, index) in group.item" :key="index"
                :uri="card.uri"
                :icon="card.img"
                :name="card.cname"
                :tip="card.tip"
				:num="card.num"
				:channelid="card.channelid"
				@on-click="handleRead">
                </ColumnCard>
            </div>
        </div>
    </div>
</template>

<script>
import ColumnCard from '@/components/ColumnCard.vue';
export default {
	props: {
		columnList: {
			type: Array,
			default () { return []; }
		}
	},
	methods: {
		handleClick (group) {
			this.$set(group, 'display', !group.display);
		},
		handleRead (e, channelid, uri) {
			this.$emit('on-read', channelid, uri);
		}
	},
	components: {
		ColumnCard
	}
};
</script>

<style lang="scss" scoped>

</style>
